import React from 'react';
import { useSelector } from 'react-redux';
import classes from './styles.module.scss';

function LoadingProgress() {
  const { loadProgress } = useSelector((store) => store.loadingProgress);

  return (
    <>
      {' '}
      {(loadProgress.status) && (
        <div className={classes.loading_bar}>
          <div style={{ width: `${loadProgress.percent}% ` }} />
          {loadProgress.status}
          {loadProgress.percent ? ` ${loadProgress.percent}%` : ''}
        </div>
      )}
    </>
  );
}

export default LoadingProgress;
